import { Slot } from '@radix-ui/react-slot'
import { type VariantProps, cva } from 'class-variance-authority'
import clsx from 'clsx'
import React from 'react'

import { textVariants } from '@/components-latest/primitives/Text'

import Styles from './Tag.module.scss'

const tagVariants = cva(Styles.tagBase, {
  variants: {
    variant: {
      fill: Styles.fill,
      outline: Styles.outline
    },
    size: {
      large: clsx(Styles.large, textVariants({ variant: 'subtitle' })),
      medium: clsx(Styles.medium, textVariants({ variant: 'body' })),
      small: clsx(Styles.small, textVariants({ variant: 'caption' })),
      xSmall: clsx(Styles.xSmall, textVariants({ variant: 'tinyCaption' }))
    },
    intent: {
      default: Styles.default,
      positive: Styles.positive,
      negative: Styles.negative,
      warning: Styles.warning,
      info: Styles.info,
      secondary: Styles.secondary
    }
  }
})

interface ITagProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof tagVariants> {
  asChild?: boolean
}

const Tag = React.forwardRef<HTMLDivElement, ITagProps>(
  ({ className, variant, size, intent, asChild = false, ...props }, ref) => {
    const Component = asChild ? Slot : 'div'

    return (
      <Component
        className={clsx(tagVariants({ variant, size, intent, className }))}
        ref={ref}
        {...props}
      />
    )
  }
)
Tag.displayName = 'Tag'

export { tagVariants }
export type { ITagProps }
export default Tag
